<template>
  <!--广告新增  -->
  <div class="adverAdd">
    <el-form
      :model="EditData"
      :rules="adverRule"
      label-position="top"
      ref="ruleForm"
      style="marginleft: 15px"
    >
      <el-row>
        <el-col :span="18">
          <el-form-item label="标题" prop="title">
            <el-input
              placeholder="请输入内容"
              v-model="EditData.title"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <el-form-item label="链接" prop="linkTo">
            <el-input
              placeholder="请输入内容"
              v-model="EditData.linkTo"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="开始时间" prop="startDate">
            <el-date-picker
              v-model="EditData.startDate"
              type="date"
              placeholder
              clearable
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="结束时间" prop="endDate">
            <el-date-picker
              v-model="EditData.endDate"
              type="date"
              placeholder
              clearable
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="页面类型" prop="pageType">
            <el-select
              placeholder="请选择"
              v-model="EditData.pageType"
              id="pageTypes"
              clearable
              @change="pageChange"
            >
              <el-option
                v-for="item in pageType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="广告图片类型" prop="isHomeRotation">
            <el-select
              placeholder="请选择"
              v-model="EditData.isHomeRotation"
              id="imgTypes"
              clearable
            >
              <el-option
                v-for="item in imgType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
                <span style="float: left">{{ item.label }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{
                  item.fen
                }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="权重" prop="sort">
            <el-date-picker
              v-model="EditData.sort"
              type="datetime"
              placeholder="选择日期时间"
              format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item
          class="banner"
          label="图片"
          prop="editImgUrl"
          ref="editImgUrl"
        >
          <el-upload
            class="avatar-uploader"
            action="https://jsonplaceholder.typicode.com/posts/"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="handlehouseUpt"
            :on-success="handleHouseSuccess"
            :before-upload="beforeUpload"
          >
            <img v-if="editImg" :src="editImg" class="avatar" />

            <i
              :class="
                adverLoad
                  ? 'el-icon-loading'
                  : 'el-icon-plus avatar-uploader-icon'
              "
              style="margintop: 10px; font-size: 50px; marginleft: 5px"
              v-else
            ></i>
          </el-upload>
        </el-form-item>
      </el-row>
      <el-row>
        <el-button
          type="primary"
          @click="adverEditSubmit()"
          style="margin: 20px 650px"
          v-if="menuPerm('floorAD:update')"
          >保存</el-button
        >
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    var editValiIcon = (rule, value, callback) => {
      // 图片验证
      // alert(this.$refs.imgUrl)
      if (this.editImg == "") {
        callback(new Error("封面图不能为空"));
      } else {
        callback();
      }
    };
    var addValiIcon = (rule, value, callback) => {
      // 图片验证
      // alert(this.$refs.imgUrl)
      if (this.addImg == "") {
        callback(new Error("封面图不能为空"));
      } else {
        callback();
      }
    };
    return {
      backOpen: true, //开关
      adverLoad: false, //广告load

      addImg: "", //广告添加上传,
      editImg: require("../../assets/upt.jpg"), //修改广告上传
      EditData: "", //修改的数据
      AdverUptImg: [], //广告上传空的数组
      adverAdd: {
        title: "", //标题
        linkTo: "", //连接
        startDate: "", //开始时间
        endDate: "", //结束时间
        pageType: "", //页面类型
        isHomeRotation: "", //广告图片类型
        imgUrl: "", //图片
        sort: "", //权重
      },
      // imgTypeAdd: [], //添加的图片类型

      //图片类型---修改：
      imgType: [
        // {
        //   label: "轮播图",
        //   value: "1",
        //   fen: "（1200*675）"
        // },
        // {
        //   label: "长条",
        //   value: "2",
        //   fen: "（1120*100）"
        // },
        // {
        //   label: "右侧-方块",
        //   value: "3",
        //   fen: "（262*336）"
        // },
        // {
        //   label: "顶部-长方图",
        //   value: "4",
        //   fen: "（1200*300）"
        // }
      ],

      //房产首页--联动
      imgType_lun: [
        {
          label: "轮播图",
          value: "1",
          fen: "（1200*675）",
        },
      ],
      //新房列表页--联动
      imgType_lie: [
        {
          label: "长条",
          value: "2",
          fen: "（1120*100）",
        },
        {
          label: "右侧-方块",
          value: "3",
          fen: "（262*336）",
        },
      ],
      //房产详情页--联动
      imgType_xiang: [
        {
          label: "顶部-长方图",
          value: "4",
          fen: "（1200*300）",
        },
        {
          label: "长条",
          value: "2",
          fen: "（1200*55）",
        },
        {
          label: "右侧方块",
          value: "3",
          fen: "（350*366）",
        },
      ],
      //网站首页--联动
      imgType_index: [
        {
          label: "顶部-长方",
          value: "4",
          fen: "（1200*470）",
        },
        {
          label: "右侧方块",
          value: "3",
          fen: "（356*430）",
        },
      ],

      //页面类型：
      pageType: [
        {
          label: "房产首页",
          value: "0",
        },
        {
          label: "房产列表页",
          value: "1",
        },
        {
          label: "房产详情页",
          value: "2",
        },
        {
          label: "新闻推荐页",
          value: "3",
        },
      ],
      //表单校验：
      adverRule: {
        startDate: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        endDate: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        title: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        linkTo: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        isHomeRotation: [
          { required: true, message: "内容不能为空", trigger: "change" },
        ],
        pageType: [
          { required: true, message: "内容不能为空", trigger: "change" },
        ],
        addImgUrl: [
          { required: true, validator: addValiIcon, trigger: "blur" },
        ],
        editImgUrl: [
          { required: true, validator: editValiIcon, trigger: "blur" },
        ],
      },
    };
  },
  props: ["Detaildata"],
  methods: {
    //转base64
    getBase64(file) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file.raw);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },
    //上传图片限制
    beforeUpload(file, fileList) {
      return new Promise((resolve) => {
        // 图片压缩
        let reader = new FileReader(),
          img = new Image();
        reader.readAsDataURL(file);
        reader.onload = function (e) {
          img.src = e.target.result;
        };

        img.onload = function () {
          let canvas = document.createElement("canvas");
          let context = canvas.getContext("2d");
          let width = "100";
          let height = "100";
          let originWidth = width;
          let originHeight = height;

          canvas.width = originWidth;
          canvas.height = originHeight;

          context.clearRect(0, 0, originWidth, originHeight);
          context.drawImage(img, 0, 0, originWidth, originHeight);

          canvas.toBlob(
            (blob) => {
              let imgFile = new File([blob], file.name, { type: file.type }); // 将blob对象转化为图片文件
              resolve(imgFile);
            },
            file.type,
            0.2
          ); // file压缩的图片类型
        };
      });
    },
    //上传成功：
    handleHouseSuccess(res, file) {
      this.$refs.uptImg.clearValidate();
      //   this.addImg = URL.createObjectURL(file.raw);
    },
    //广告新增/修改上传图片
    handlehouseUpt(file, fileList) {
      this.adverLoad = true;
      this.AdverUptImg = [];
      this.getBase64(file).then((resBase64) => {
        this.AdverUptImg.push(resBase64);
        if (this.AdverUptImg) {
          this.postAxios("/file/uploadBase64", {
            fileList: this.AdverUptImg,
          }).then((res) => {
            if (res.success == true) {
              this.$message.success("上传成功");
              if (this.props == "add") {
                this.addImg = res.content[0]; //上传的图片
                this.adverAdd.imgUrl = this.addImg; //接口url参数
                this.AdverUptImg = [];
                this.$refs.addImgUrl.clearValidate();
              } else {
                this.editImg = res.content[0]; //上传的图片
                this.EditData.imgUrl = this.editImg; //接口url参数
                this.AdverUptImg = [];
                this.$refs.editImgUrl.clearValidate();
              }
            } else if (res.success == false) {
              this.$message.error(res.message);
            }
            if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            }
          });
        }
      });
    },
    //转时间
    addZero(num) {
      return num < 10 ? "0" + num : num;
    },
    //转时间
    formatDateTime(date) {
      const time = new Date(Date.parse(date));
      const Y = time.getFullYear() + "-";
      const M = this.addZero(time.getMonth() + 1) + "-";
      const D = this.addZero(time.getDate()) + " ";
      const h = this.addZero(time.getHours()) + ":";
      const m = this.addZero(time.getMinutes()) + ":";
      const s = this.addZero(time.getSeconds());
      return Y + M + D + h + m + s;
    },

    //添加保存：
    adverAddSubmit(formName) {
      var sorts =
        new Date(this.formatDateTime(this.adverAdd.sort)).getTime() / 1000;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.postAxios("/floorAD/insert", {
            title: this.adverAdd.title, //标题
            linkTo: this.adverAdd.linkTo, //链接
            startDate: this.formatDateTime(this.adverAdd.startDate), //开始时间
            endDate: this.formatDateTime(this.adverAdd.endDate), //结束时间
            imgUrl: this.adverAdd.imgUrl, //url
            isHomeRotation: this.adverAdd.isHomeRotation, //广告图片类型 1轮播 2长条 3正方 4长方
            pageType: this.adverAdd.pageType, //页面类型
          }).then((res) => {
            if (res.success == true) {
              this.$message.success("添加成功");
              this.$router.push({ path: "/advertisemen" });
            } else if (res.success == false) {
              this.$message.error(res.message);
            }

            if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            }
          });
        } else {
          return false;
        }
      });
    },
    //修改保存：
    adverEditSubmit() {
      var that=this;
      var sorts =
        new Date(this.formatDateTime(this.EditData.sort)).getTime() / 1000;

      this.postAxios("/floorAD/update", {
        id: this.EditData.id,
        title: this.EditData.title, //标题
        linkTo: this.EditData.linkTo, //链接
        startDate: this.formatDateTime(this.EditData.startDate), //开始时间
        endDate: this.formatDateTime(this.EditData.endDate), //结束时间
        imgUrl: this.EditData.imgUrl, //url
        isHomeRotation: this.EditData.isHomeRotation, //广告图片类型 1轮播 2长条 3正方 4长方
        pageType: this.EditData.pageType, //页面类型
        sort: sorts, //权重
      }).then((res) => {
        if (res.success == true) {
          // console.log(startDate,'startDate')
          this.$message.success("修改成功");
          console.log(111222)
          // that.$parent.adverInit();
           this.$emit('adverInit');
          // this.$router.push({ path: "/advertisemen" });
        } else if (res.success == false) {
          this.$message.error(res.message);
        }

        if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    adverLian(val) {
      switch (val) {
        case "0":
          this.imgType = this.imgType_lun;
          break;
        case "1":
          this.imgType = this.imgType_lie;
          break;
        case "2":
          this.imgType = this.imgType_xiang;
          break;
        case "3":
          this.imgType = this.imgType_index;
          break;
        default:
          this.imgType = [
            {
              label: "",
              value: "",
              fen: "",
            },
          ];
          this.imgTypeAdd = [
            {
              label: "",
              value: "",
              fen: "",
            },
          ];
          break;
      }
    },
    //二级联动：
    pageChange(val) {
      this.adverLian(val);
    },
  },
  created() {
    this.EditData = this.Detaildata; //修改的数据

    if (this.EditData.imgUrl == "") {
      this.editImg = "../../assets/upt.jpg";
    } else {
      this.editImg = this.EditData.imgUrl;
    }

    // console.log(this.EditData);
  },
  watch: {
    Detaildata(newVal, oldVal) {
      this.EditData = this.Detaildata;
      if (this.Detaildata.imgUrl == "") {
        this.editImg = "../../assets/upt.jpg";
      } else {
        this.editImg = this.EditData.imgUrl;
      }
    },
  },
};
</script>
<style scoped lang="less">
.adverAdd {
  width: 100%;
  height: 100%;
  // background: red;
  // /deep/ .el-input__inner {
  //   -webkit-appearance: none;
  //   background-color: #fff;
  //   background-image: none;
  //   border-radius: 4px;
  //   border: 1px solid #dcdfe6;
  //   box-sizing: border-box;
  //   color: #606266;
  //   display: inline-block;
  //   font-size: inherit;
  //   height: 40px;
  //   line-height: 40px;
  //   outline: 0;
  //   padding: 0 15px;
  //   transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  //   width: 300px;
  //   margin-left: 10px;
  // }
  /deep/ .el-upload {
    display: inline-block;
    text-align: center;
    cursor: pointer;
    outline: 0;
    width: 200px;
    height: auto;
    border: 2px solid #eee;
    /deep/ .el-icon-plus .avatar-uploader-icon {
      margin-top: 100px !important;
      font-weight: 800;
      font-size: 100;
    }
    img {
      // margin: 0 auto;
      width: 100%;
      height: auto;
    }
  }
  /deep/ .el-button--primary {
    color: #fff;
    background-color: #409eff;
    border-color: #409eff;
    width: 100px;
    margin-top: 10px;
    margin-left: 10px;
  }
}
</style>